import { lazy } from 'react'

export const SvberLoginPage = lazy(
  () => import(/* webpackChunkName: 'svber' */ './login/login-page')
)
export const SvberErrorPage = lazy(
    () => import(/* webpackChunkName: 'svber' */ './error/error-page')
)
export const DashboardPage = lazy(
  () => import(/* webpackChunkName: 'svber' */ './dashboard/dashboard-page')
)
export const DataManagementView = lazy(
  () => import(/* webpackChunkName: 'svber' */ './data-management')
)
export const Applications = lazy(
  () => import(/* webpackChunkName: 'svber' */ './applications')
)
export const CompanyProfileView=lazy(
  ()=> import (/* webpackChunkName: 'svber' */ './company-profile')
)
export const AdminPanelView=lazy(
  ()=> import (/* webpackChunkName: 'svber' */ './layout/admin-panel')
)
export const ADFTracking = lazy(
  () => import(/* webpackChunkName: 'svber' */ './adf-tracking')
)